import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Rx';

import { Api } from "./api";

@Injectable()
export class PKService {
  private endpoint: string = 'pks';

  constructor(private api: Api) {
  }

  public getPks(page): Observable<any> {
    let params = {
      page: page,
      size: 30000,
      withLastMeasure: true
    };

    return this.api.get(this.endpoint, params)
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }

  public getPksLastUpdate(): Observable<string> {
    return this.api.get(this.endpoint + '/maxDate')
      .map(res => res.text() ? res.json() : null)
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pk.service.ts